import { definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

export type ExportOffersToSearchBody = definitions['EXPORT_OFFERS_TO_SEARCH_BODY'];
export type ExportOffersToSearchResult = definitions['EXPORT_OFFERS_TO_SEARCH_RESULT'];

const exportOffersToSearch = async (body: ExportOffersToSearchBody): Promise<ExportOffersToSearchResult> => {
  const response = await cruisesAPI.http.post<{ result: ExportOffersToSearchResult }>({
    resource: 'offers/export-to-search',
    body,
  });

  return response.result;
};

export default {
  exportOffersToSearch,
};
